import React, { Fragment } from 'react';
import propTypes from 'prop-types';
import { FormGroup, Input, Label } from 'reactstrap';

import * as devices from '../web-interface-devices';
import styles from './CanvasResizer.css';

/**
 * Returns canvas bottom component
 * @param {object} props - component props
 * @param {object} props.dimensions - containing diemntions of the canvas.
 * @param {Function} props.onDeviceSelected - action to be dispatched on device selection.
 * @returns {React.Component} the canvas bottom component.
 */
const CanvasResizer = ({
  disableContentLinks,
  device,
  height,
  onDeviceChange,
  onHeightChange,
  onWidthChange,
  showFullscreenIframe,
  toggleContentLinks,
  width
}) => {
  const isReadonly = !!devices.RESPONSIVE_DESKTOP_DEVICES[device];

  return (
    <Fragment>
      {!showFullscreenIframe && (
        <span>
          <Input
            type="select"
            value={device}
            onChange={e => onDeviceChange(e.target.value)}
            data-test-id="canvas-device"
          >
            {devices.RESPONSIVE_DEVICES.map(({ key, value }) => (
              <option key={key} value={value}>
                {key}
              </option>
            ))}
          </Input>
        </span>
      )}
      <span className={styles.textbox}>
        <Input
          type="text"
          value={width}
          onChange={e => onWidthChange(e.target.value)}
          readOnly={isReadonly || showFullscreenIframe}
        />
      </span>
      <h5 className="m-0">&times;</h5>
      <div className={styles.textbox}>
        <Input
          type="text"
          value={height}
          onChange={e => onHeightChange(e.target.value)}
          readOnly={isReadonly || showFullscreenIframe}
        />
      </div>
      <FormGroup check inline>
        <Label check>
          <Input type="checkbox" checked={disableContentLinks} onChange={toggleContentLinks} />
          Disable Content Links
        </Label>
      </FormGroup>
    </Fragment>
  );
};

CanvasResizer.propTypes = {
  device: propTypes.string.isRequired,
  disableContentLinks: propTypes.bool.isRequired,
  height: propTypes.number.isRequired,
  onDeviceChange: propTypes.func.isRequired,
  onHeightChange: propTypes.func.isRequired,
  onWidthChange: propTypes.func.isRequired,
  showFullscreenIframe: propTypes.bool.isRequired,
  toggleContentLinks: propTypes.func.isRequired,
  width: propTypes.number.isRequired
};

export default CanvasResizer;
